import { node } from "~/util/dom";

export function createMarkerPopup() {
	const container = node("div", { className: "ui-marker-popup" });
	// fake marker
	const marker = node("img", { src: "/img/marker/little.png" });
	// karta s infem
	const card = node("div", { className: "ui-marker-popup__card" });

	container.append(card, marker);

	return {
		container,
		card,
	};
}
